import { proxy } from 'valtio'
import { useSnapshot } from 'valtio/react'

// 文件说明：维护 OP 节点创建后的本地一次性编辑器打开意图。

const nodeOpEditIntentStore = proxy<Record<string, boolean>>({})

// 记录某个节点在 OP 面板渲染后需要自动打开编辑器。
export function requestOpenNodeOpEditor(nodeId: string) {
  nodeOpEditIntentStore[nodeId] = true
}

// 读取并消费某个节点的自动打开意图，成功消费后立即清除。
export function consumeOpenNodeOpEditorIntent(nodeId: string) {
  const shouldOpen = nodeOpEditIntentStore[nodeId] === true
  if (shouldOpen) {
    delete nodeOpEditIntentStore[nodeId]
  }
  return shouldOpen
}

// 清理某个节点残留的自动打开意图，避免卸载后再次选中误触发。
export function clearNodeOpEditorOpenIntent(nodeId: string) {
  if (nodeOpEditIntentStore[nodeId] !== undefined) {
    delete nodeOpEditIntentStore[nodeId]
  }
}

// 订阅某个节点是否存在自动打开编辑器的意图。
export function useNodeOpEditorOpenIntent(nodeId?: string) {
  const snapshot = useSnapshot(nodeOpEditIntentStore)

  if (!nodeId) {
    return false
  }

  return snapshot[nodeId] === true
}

// 维护文本节点双击/操作后打开编辑器的意图
const nodeTextEditIntentStore = proxy<Record<string, boolean>>({})

export function requestOpenTextNodeEditor(nodeId: string) {
  nodeTextEditIntentStore[nodeId] = true
}

export function useTextNodeEditorOpenIntent(nodeId: string) {
  const snapshot = useSnapshot(nodeTextEditIntentStore)
  return snapshot[nodeId] === true
}

export function consumeTextNodeEditorOpenIntent(nodeId: string) {
  const shouldOpen = nodeTextEditIntentStore[nodeId] === true
  if (shouldOpen) {
    delete nodeTextEditIntentStore[nodeId]
  }
  return shouldOpen
}
